<template>
  <div id="app">
    <AppHeader />
    <router-view />
    <AppFooter />
    <el-backtop :bottom="50" :right="40">
      <div class="backtop-btn">
        <el-icon><ArrowUp /></el-icon>
      </div>
    </el-backtop>
  </div>
</template>

<script setup>
import { ArrowUp } from '@element-plus/icons-vue'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.backtop-btn {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-color);
  color: #fff;
  border-radius: 50%;
  font-size: 20px;
  box-shadow: 0 2px 12px rgba(4, 53, 156, 0.3);
}
</style>
